import { render, staticRenderFns } from "./ProfileLeft.vue?vue&type=template&id=6078f5c7&scoped=true"
import script from "./ProfileLeft.vue?vue&type=script&lang=ts"
export * from "./ProfileLeft.vue?vue&type=script&lang=ts"
import style0 from "./ProfileLeft.vue?vue&type=style&index=0&id=6078f5c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078f5c7",
  null
  
)

export default component.exports